import React from 'react';
import { Typography } from "@mui/material";

export function SectionHeader({ header }) {
    return (
        <Typography
            variant="h5"
            component="h2"
            sx={{
                fontWeight: 700,
                marginBottom: { xs: "24px", sm: "32px" },
                color: '#1e293b',
                letterSpacing: '-0.02em',
            }}
        >
            {header}
        </Typography>
    );
}
